import { defineComponent as _defineComponent } from 'vue'
import useProfileState from '@/state/profile/profileState';
import useProfilePreview from '@/state/profile/profilePreview';
import { ProfileSectionKey } from '@/models/Profile';
import usePageState from '@/state/pageState';
import getAxiosResponseErrorCode from '@/utils/getAxiosResponseErrorCode';
import {
  inject, ref, Ref, toRefs
} from 'vue';
import ConfirmButtons from '@/components/molecules/ConfirmButtons.vue';
import { AxiosError } from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileEditActionButtons',
  props: {
  saveFunction: {
    type: Function as () => any,
    default: () => null,
  },
  disabled: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props;



const { saveFunction } = toRefs(props) as {
      saveFunction: Ref<() => Promise<any>>;
    };
const isSaving = ref(false);
const { closeEditSection, loadProfile } = useProfileState();
const { discardSection } = useProfilePreview();
const { globalErrorMessage } = usePageState();
const currentEditSection = inject<Ref<string>>('currentEditSection');
const sectionBusy = inject<Ref<boolean> | null>('profileSectionBusy', null);

const close = () => {
  closeEditSection(currentEditSection?.value ?? '');
};

const save = async () => {
  if (saveFunction.value) {
    isSaving.value = true;
    if (sectionBusy) sectionBusy.value = true;

    try {
      const stayInEditor = await saveFunction.value();
      if (stayInEditor === 'abort') return;

      try {
        await loadProfile({ silent: true });
      } catch (error) {
        globalErrorMessage.value = {
          i18Key: 'profile.common.reloadFailedAfterSave',
          code: getAxiosResponseErrorCode(error as AxiosError) ?? 'UNKNOWN_ERROR',
          component: 'ProfileEditActionButtons.vue',
          withoutReload: true,
          timeoutMs: 15000,
        };
      }
      // Editor save committed user-edited content; any AI preview for this
      // section is now stale, so clear the slot to keep the review bar from
      // reappearing with the original suggestion. Cancel intentionally skips
      // this so the bar comes back with the unchanged preview.
      discardSection((currentEditSection?.value ?? '') as ProfileSectionKey);
      if (!stayInEditor) close();
    } finally {
      isSaving.value = false;
      if (sectionBusy) sectionBusy.value = false;
    }
  }
};

return { __sfc: true,props, saveFunction, isSaving, closeEditSection, loadProfile, discardSection, globalErrorMessage, currentEditSection, sectionBusy, close, save, ConfirmButtons }
}

})